import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHead, TableRow, Grid } from '@mui/material';
import { Prompt } from 'react-router-dom';
import OfferFinancialServicesItemComponent from './OfferFinancialServicesItemComponent';
import { RightsContext } from 'providers/RightsContext';
import OfferFinancialServicesHeaderComponent from './OfferFinancialServicesHeaderComponent';
import OfferFinancialServicesItemHeaderComponent from './OfferFinancialServicesItemHeaderComponent';
import { Button } from '@totalsoft/rocket-ui';
import CollapseOrBlankCard from 'components/common/CollapseOrBlankCard';

export const OfferFinancialServicesListComponent = ({
  validationInfo,
  t,
  onServiceSelectionChange,
  onServiceItemPropertyChange,
  onServiceItemComputeValue,
  wheelSizes,
  saving,
  isDirty,
  onHeaderPropertyChange,
  onSave,
  servicesLoading,
  document,
  editable,
  handleModifyData,
  currencyCode
}) => {
  const handleServiceSelectionChange = (serviceTypeId, serviceCategoryId, event) => {
    const selected = event.target.checked;
    onServiceSelectionChange(serviceTypeId, serviceCategoryId, selected);
  };

  const handleServiceItemPropertyChange = (serviceTypeId, serviceCategoryId, propName, value) => {
    onServiceItemPropertyChange(serviceTypeId, serviceCategoryId, propName, value);
  };

  const handleServiceItemComputeValue = (serviceTypeId, serviceCategoryId) => () => {
    onServiceItemComputeValue(serviceTypeId, serviceCategoryId);
  };

  const handleValidationInfo = (validationInfo, indexService, indexCategory) => {
    if (
      typeof indexService !== 'undefined' &&
      typeof indexCategory !== 'undefined' &&
      typeof validationInfo.categoryServices !== 'undefined' &&
      Object.keys(validationInfo.categoryServices).length !== 0 &&
      typeof validationInfo.categoryServices[indexCategory] !== 'undefined' &&
      Object.keys(validationInfo.categoryServices[indexCategory].services).length !== 0
    )
      return validationInfo.categoryServices[indexCategory].services[indexService];
  };

  const { readOnlyFull, financialServicesWrite, isImage } = useContext(RightsContext);

  return (
    <>
      <Prompt when={isDirty} message={t('LeavingWithoutSaving')} />
      <Grid container spacing={1}>
        <OfferFinancialServicesHeaderComponent
          validationInfo={validationInfo}
          wheelSizes={wheelSizes}
          onHeaderPropertyChange={onHeaderPropertyChange}
          header={document.header}
        />

        <Grid item xs={12}>
          {document.categoryServices.length > 0 &&
            document.categoryServices.map((category, indexCategory) => {
              if (category.services.length > 0)
                return (
                  <CollapseOrBlankCard
                    id={'offerFinancialServicesCard_itemCard_' + indexCategory}
                    key={category.serviceCategoryId}
                    expanded={false}
                    canExpand={financialServicesWrite}
                    subheader={
                      <OfferFinancialServicesItemHeaderComponent
                        idx={indexCategory}
                        servicesLoading={servicesLoading}
                        category={category}
                        readOnlyFull={readOnlyFull}
                        onChange={handleServiceSelectionChange}
                        financialServicesWrite={financialServicesWrite}
                        currencyCode={currencyCode}
                      />
                    }
                  >
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell>
                            <strong>{t('OfferEdit.FinancialServices.Name')}</strong>
                          </TableCell>
                          <TableCell align={'right'}>
                            <strong>{t('OfferEdit.FinancialServices.Percent')}</strong>
                          </TableCell>
                          <TableCell align={'right'}>
                            <strong>{t('OfferEdit.FinancialServices.MonthlyValue')}</strong>
                          </TableCell>
                          <TableCell align={'right'}>
                            <strong>{t('OfferEdit.FinancialServices.Discount')}</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {category.services.map((service, index) => {
                          return (
                            <OfferFinancialServicesItemComponent
                              categoryIndex={indexCategory}
                              itemIndex={index}
                              validationInfo={handleValidationInfo(validationInfo, index, indexCategory) || {}}
                              key={service.serviceTypeId}
                              item={service}
                              readOnlyFull={readOnlyFull}
                              category={category}
                              loading={servicesLoading.some(x => x.serviceTypeId === service.serviceTypeId && x.value === true)}
                              onChange={handleServiceSelectionChange}
                              editable={readOnlyFull || editable}
                              onServiceItemPropertyChange={handleServiceItemPropertyChange}
                              onServiceItemComputeValue={handleServiceItemComputeValue(service.serviceTypeId, category.serviceCategoryId)}
                              saving={saving}
                              disabled={!financialServicesWrite}
                            />
                          );
                        })}
                      </TableBody>
                    </Table>
                  </CollapseOrBlankCard>
                );
              else return <div></div>;
            })}
          {document.services.length > 0 ? (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>{t('OfferEdit.FinancialServices.Name')}</strong>
                  </TableCell>
                  <TableCell align={'right'}>
                    <strong>{t('OfferEdit.FinancialServices.Percent')}</strong>
                  </TableCell>
                  <TableCell align={'right'}>
                    <strong>{t('OfferEdit.FinancialServices.MonthlyValue')}</strong>
                  </TableCell>
                  <TableCell align={'right'}>
                    <strong>{t('OfferEdit.FinancialServices.Discount')}</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {document.services.map((service, index) => {
                  return (
                    <OfferFinancialServicesItemComponent
                      itemIndex={index}
                      validationInfo={validationInfo.services[index] || {}}
                      key={service.serviceTypeId}
                      readOnlyFull={readOnlyFull}
                      item={service}
                      loading={servicesLoading.some(x => x.serviceTypeId === service.serviceTypeId && x.value === true)}
                      onChange={handleServiceSelectionChange}
                      editable={readOnlyFull || editable}
                      onServiceItemPropertyChange={handleServiceItemPropertyChange}
                      onServiceItemComputeValue={handleServiceItemComputeValue(service.serviceTypeId, null)}
                      saving={saving}
                      disabled={!financialServicesWrite}
                    />
                  );
                })}
              </TableBody>
            </Table>
          ) : (
            <div></div>
          )}
        </Grid>
        {!isImage && (
          <Grid item xs={12}>
            <Button
              id={'offerFinancialServicesCard_modifyBtn'}
              onClick={handleModifyData}
              color='primary'
              disabled={
                readOnlyFull ||
                !financialServicesWrite ||
                editable ||
                saving ||
                (document.services.length === 0 && document.categoryServices.length === 0)
              }
            >
              {t('Change')}
            </Button>
            <Button
              id={'offerFinancialServicesCard_saveBtn'}
              color='primary'
              onClick={onSave}
              disabled={
                readOnlyFull ||
                saving ||
                !validationInfo.isValid ||
                !isDirty ||
                !financialServicesWrite ||
                servicesLoading.some(x => x.value === true)
              }
            >
              {saving ? t('Saving') + '...' : t('Save')}
            </Button>
          </Grid>
        )}
      </Grid>
    </>
  );
};

OfferFinancialServicesListComponent.propTypes = {
  validationInfo: PropTypes.object.isRequired,
  onServiceSelectionChange: PropTypes.func.isRequired,
  onHeaderPropertyChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  wheelSizes: PropTypes.array.isRequired,
  saving: PropTypes.bool.isRequired,
  isDirty: PropTypes.bool.isRequired,
  servicesLoading: PropTypes.array.isRequired,
  document: PropTypes.object.isRequired,
  onServiceItemPropertyChange: PropTypes.func.isRequired,
  onServiceItemComputeValue: PropTypes.func.isRequired,
  editable: PropTypes.bool.isRequired,
  handleModifyData: PropTypes.func.isRequired,
  currencyCode: PropTypes.string
};

export default withTranslation()(OfferFinancialServicesListComponent);
